import {
  ExamLocationRequestRoomPhysicalInfoForm,
  mapPhysicalInfoToDefaultValues,
  useExamRoomRequestInfo,
} from '@exam-center/exam-location-management';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { PaperSection } from '@shared/components';
import { usePermission, validatePermissions } from '@shared/permissions';

export default function ExamLocationRequestRoomPhysicalInfoPage() {
  const { examRoomRequestInfo, isReadonly } = useExamRoomRequestInfo();
  const { permissions } = usePermission();

  const hasUpdatePermission = validatePermissions(
    APP_PERMISSIONS.EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_REQUEST.UPDATE,
    permissions,
  );

  const defaultValues = mapPhysicalInfoToDefaultValues(
    examRoomRequestInfo.examRoomRequestPhysicalInfo?.info,
  );

  return (
    <PaperSection title='ข้อมูลทางกายภาพ'>
      <ExamLocationRequestRoomPhysicalInfoForm
        isReadonly={isReadonly || !hasUpdatePermission}
        defaultValues={defaultValues}
      />
    </PaperSection>
  );
}
